//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';
import angular from 'angular';

import template from 'app/components/nav3/storefronts-menu.html';
import { dashboardStatesByName as states } from 'app/top-level-states';

angular.module('curalate').component('storefrontsMenu', {
  template,
  controller: [
    'SessionVarsService',
    function (SessionVarsService) {
      this.$onInit = () => {
        this.isInstashopEnabled = states.instashop.data.hasAccess();
        this.isGalleriesEnabled = SessionVarsService.isFeatureEnabled(
          FeatureNames.Galleries,
        );
        this.isEmailBuilderEnabled = SessionVarsService.isFeatureEnabled(
          FeatureNames.EmailBuilder,
        );
        this.isGoogleAssetFeedsEnabled = SessionVarsService.isFeatureEnabled(
          FeatureNames.AssetFeedTagging,
        );
        this.isLike2BuyV2Enabled = SessionVarsService.isFeatureEnabled(
          FeatureNames.InstagramLike2buyV2,
        );
        this.isLike2BuyEnabled = SessionVarsService.isFeatureEnabled(
          FeatureNames.Like2Buy,
        );
        this.isLike2BuyTiktokEnabled = SessionVarsService.isFeatureEnabled(
          FeatureNames.Like2BuyTiktok,
        );
        this.isInstagramShopsUgcEnabled = SessionVarsService.isFeatureEnabled(
          FeatureNames.InstagramShopsUgc,
        );
        this.isTributarySelfServeEnabled = SessionVarsService.isFeatureEnabled(
          FeatureNames.TributarySelfServe,
        );
        this.isInstagramAdsContentAllowlistingEnabled =
          SessionVarsService.isFeatureEnabled(
            FeatureNames.InstagramAdsContentAllowlisting,
          );
        this.isPromotedPostsEnabled = SessionVarsService.isFeatureEnabled(
          FeatureNames.PromotedPosts,
        );
        this.isTiktokSparkAdsEnabled = SessionVarsService.isFeatureEnabled(
          FeatureNames.TiktokSparkAds,
        );
        this.isRevealPageEnabled = SessionVarsService.isFeatureEnabled(
          FeatureNames.RevealPage,
        );
        this.isGalleriesFeatureEnabled = SessionVarsService.isFeatureEnabled(
          FeatureNames.Galleries,
        );
        this.isBazaarvoiceNetworkFeatureEnabled =
          SessionVarsService.isFeatureEnabled(
            FeatureNames.BazaarvoiceNetworkSyndicationFrontend,
          );
        this.isInstashopFeatureEnabled = SessionVarsService.isFeatureEnabled(
          FeatureNames.Instashop,
        );
        this.isCuralateEmployee = SessionVarsService.isCuralateEmployee();

        this.isLike2BuyInstagramEnabled =
          this.isLike2BuyEnabled &&
          (!this.isLike2BuyV2Enabled || this.isCuralateEmployee);

        this.isSocialVisible =
          this.isLike2BuyEnabled ||
          this.isLike2BuyV2Enabled ||
          this.isLike2BuyTiktokEnabled ||
          this.isTributarySelfServeEnabled ||
          this.isInstagramShopsUgcEnabled;

        this.getSocialState = () => {
          if (this.isLike2BuyInstagramEnabled) {
            return 'instagramAccount.like2buy';
          } else if (this.isLike2BuyTiktokEnabled) {
            return 'tiktok.like2buy';
          } else if (this.isLike2BuyV2Enabled) {
            return 'instagramAccount.l2b-v2';
          } else if (this.isInstagramShopsUgcEnabled) {
            return 'instagramAccount.instagram-shops';
          } else if (this.isTributarySelfServeEnabled) {
            return 'showroom';
          }
          return '';
        };

        this.isPaidSocialVisible =
          this.isInstagramAdsContentAllowlistingEnabled ||
          this.isPromotedPostsEnabled ||
          this.isTiktokSparkAdsEnabled;

        this.getPaidSocialState = () => {
          if (this.isInstagramAdsContentAllowlistingEnabled) {
            return 'meta-ads';
          } else if (this.isPromotedPostsEnabled) {
            return 'instagramAccount.promotedPostMetrics';
          }
          return 'spark-ads';
        };

        this.isVisualSyndicationVisible =
          this.isBazaarvoiceNetworkFeatureEnabled &&
          !this.isInstashopFeatureEnabled;
      };
    },
  ],
});
